import React from "react";

// Shimmer placeholder. Pass width/height or a count of lines.
export default function Skeleton({ w = "100%", h = 16, r = 8, style }) {
  return <span className="skeleton" style={{ width: w, height: h, borderRadius: r, ...style }} />;
}

export function SkeletonRows({ rows = 3 }) {
  return (
    <>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex-between" style={{ padding: "11px 0" }}>
          <Skeleton w="40%" h={13} />
          <Skeleton w="22%" h={13} />
        </div>
      ))}
    </>
  );
}
